import React from 'react';
import { Carousel, CarouselItem } from "react-onsenui";


const ClaroVideoCarousel = ({ postChange, index, handleCheck }) => {

    return(
        <>
        <Carousel
        onPostChange={postChange}
        swipeable
        overscrollable
        autoScroll
        fullscreen
        style={{margin:"1% 1%", height:"50%", width:"98%"}}
        centered
        index={index}
      >
        <CarouselItem style={{ marginTop:"5%", height:"auto"}}>
          <iframe 
            id="iframe-claro-video"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="/animations/claro_video/paso1/Step1.html"
            style={{zIndex:-1,position:"relative"}}
          />  
        </CarouselItem>
        <CarouselItem style={{marginTop:"5%", height:"auto"}}>
          <iframe 
            id="iframe-claro-video"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="/animations/claro_video/paso2/Step2.html"
            style={{zIndex:-1,position:"relative"}}
          />
        </CarouselItem>
        <CarouselItem style={{marginTop:"5%", height:"auto"}}>
          <iframe 
            id="iframe-claro-video"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="/animations/claro_video/paso3/Step3.html"
            style={{zIndex:-1,position:"relative"}}
          />
        </CarouselItem>
        <CarouselItem style={{ marginTop:"5%", height:"auto"}}>
          <iframe 
            id="iframe-claro-video"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="/animations/claro_video/paso4/Step4.html"
            style={{zIndex:-1,position:"relative"}}
          />
        </CarouselItem>
        <CarouselItem style={{marginTop:"5%", height:"auto"}}>
          <iframe 
            id="iframe-claro-video"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="/animations/claro_video/paso5/Step5.html"
            style={{zIndex:-1,position:"relative"}}

          />
        </CarouselItem>
        <CarouselItem>
            <img src="/animations/claro_video/100x100.gif"  width="80%" style={{visibility:"hidden"}}/>
        </CarouselItem>
      </Carousel>
      <div style={{textAlign: "center", fontSize: "20px"}}>
        <span id={0} onClick={handleCheck} style={{marginRight:"2%"}}>
          {index === 0 ? "\u25CF" : "\u25CB"}
        </span>
        <span id={1} onClick={handleCheck} style={{marginRight:"2%"}}>
          {index === 1 ? "\u25CF" : "\u25CB"}
        </span>
        <span id={2} onClick={handleCheck} style={{marginRight:"2%"}}>
          {index === 2 ? "\u25CF" : "\u25CB"}
        </span>
        <span id={3} onClick={handleCheck} style={{marginRight:"2%"}}>
          {index === 3 ? "\u25CF" : "\u25CB"}
        </span>
        <span id={4} onClick={handleCheck}>
          {index === 4 ? "\u25CF" : "\u25CB"}
        </span>
      </div>
      </>
    )
}

export default ClaroVideoCarousel;